import pino, { Logger } from 'pino';

export let logger: Logger;

const initLogger = async () => {
    logger = pino({
        browser: {
            asObject: true,
        },
    });
};

export default initLogger;
